var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel',{staticClass:"border border-secondary",staticStyle:{"height":"100%","min-height":"100vh"},attrs:{"noButton":true}},[_c('template',{slot:"header"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Vehicle Scan History")])]),_c('div',{ref:"timelineChart",staticStyle:{"min-height":"100%"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }